import axios from 'axios'
import qs from 'qs'
import store from '@/store'

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/v2`,
  withCredentials: true,
  paramsSerializer: params => qs.stringify(params, { indices: false, skipNulls: true })
})

const requestInterceptor = config => {
  if (document.cookie) {
    const csrfCookie = document.cookie.split(';').find((c) => { return c.trim().startsWith('csrftoken=') })
    if (csrfCookie) {
      const csrfToken = csrfCookie.split('=')[1]
      config.headers['X-CSRFToken'] = csrfToken
    }
  }

  const demo = store.state.demo
  if (demo) {
    config.headers['DEMO'] = 1
  }

  if (store.state.brand.settings) {
    config.headers['X-Brand-ID'] = store.state.brand.settings.id
  }

  return config
}

client.interceptors.request.use(requestInterceptor, function (error) {
  return Promise.reject(error)
})

const fastClient = axios.create({
  baseURL: process.env.VUE_APP_FASTAPI_BASE_URL,
  withCredentials: true,
  paramsSerializer: params => qs.stringify(params, { indices: false, skipNulls: true })
})

fastClient.interceptors.request.use(requestInterceptor, function (error) {
  return Promise.reject(error)
})

export default {
  env: async () => fastClient.get('/env'),
  assetDetail: async pk => client.get(`/assets/${pk}/`),
  updateAsset: async (pk, payload) => client.patch(`/assets/${pk}/`, payload),
  assetDetailPropertyCreate: async (pk, payload) =>  client.post(`/assets/${pk}/properties/`, payload),

  metrics: async params => client.post('/metrics/', params),

  propertyCreate: async payload => client.post('/assets/properties/', payload),
  propertyList: async params  => client.get('/assets/properties/', { params }),
  propertyDetail: async pk => client.get(`/assets/properties/${pk}`),
  propertyUpdate: async (pk, payload) => client.patch(`/assets/properties/${pk}/`, payload),
  propertyDelete: async pk => client.delete(`/assets/properties/${pk}/`),

  assetPropertyCreate: async payload => client.post('/assets/assetproperties/', payload),
  assetPropertyList: async params => client.get('/assets/assetproperties/', { params }),
  assetPropertyDetail: async pk => client.get(`/assets/assetproperties/${pk}/`),
  assetPropertyUpdate: async (pk, payload) => client.patch(`/assets/assetproperties/${pk}/`, payload),
  assetPropertyDelete: async pk => client.delete(`/assets/assetproperties/${pk}/`),

  assetPropertyOptionList: async params => client.get('/assets/assetproperties/options/', { params }),

  topics: async params => client.get('/categories/', { params }),

  collectionCreate: async payload => client.post('/assets/collections', payload),
  collectionList: async params => client.get('/assets/collections', { params }),
  collectionDetail: async pk => client.get(`/assets/collections/${pk}`),
  collectionUpdate: async (pk, payload) => client.patch(`/assets/collections/${pk}`, payload),
  collectionDelete: async pk => client.delete(`/assets/collections/${pk}`),

  searchCreate: async payload => client.post('/search/', payload),
  searchTotalsCreate: async payload => client.post('/search/totals/', payload),
  searchExport: async payload => client.post('/search/export/', payload)
}
